import { mainSiteUrl } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-accent-50/40" id="about">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 items-center">
        <div className="w-full lg:w-[45%] flex flex-col">
          <p className="text-xs tracking-[0.2em] uppercase text-accent-600 font-medium mb-3">
            / itaobuyspreadsheet
          </p>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-[1.12]">
            What is <span className="italic text-accent-600">itaobuyspreadsheet</span>?
          </h2>
        </div>

        <div className="w-full lg:w-[55%]">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            <strong className="text-foreground-900">itaobuyspreadsheet</strong> is a structured product sourcing system designed to simplify buying from China platforms such as Taobao and 1688. Instead of manually searching thousands of listings, users can compare verified suppliers, analyze product pricing instantly, reduce sourcing risk, and save 30–70% purchasing time.
          </p>

          <div className="grid grid-cols-2 gap-3 mt-6 mb-5">
            {[
              { label: 'E-commerce Sellers', icon: 'ri-store-2-line' },
              { label: 'Dropshippers', icon: 'ri-send-plane-line' },
              { label: 'Amazon & Shopify Sellers', icon: 'ri-shopping-cart-2-line' },
              { label: 'Wholesale Buyers', icon: 'ri-box-3-line' },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-2.5 text-sm text-foreground-700">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className={`${item.icon} text-base text-accent-500`}></i>
                </div>
                <span className="whitespace-nowrap">{item.label}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-4 mt-6">
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-background-50 bg-secondary-300 flex items-center justify-center overflow-hidden"
                >
                  <i className="ri-user-line text-sm text-foreground-600"></i>
                </div>
              ))}
            </div>
            <p className="text-xs md:text-sm text-foreground-500">
              <strong className="text-foreground-800">10,000+</strong> Resellers & Dropshippers
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}